import { simulate } from '../mock-utils'
import { guideFromStay } from './real'
import type { GuiaService, GuideSection, NearbyPlace } from './types'

/**
 * Mock de la guía con los textos de PantallaGuia.dc.html (Bloque 6 §6d). Códigos:
 *  - `guia-vacia` → sin secciones · `guia-sin-wifi` → sin Wi-Fi · `guia-sin-clave` → red sin clave
 *  - `guia-html` → secciones con HTML del PMS (párrafos, listas, enlace y un script que se descarta)
 *  - `error-guia`, `offline-guia` (con copia guardada si se abrió antes), `lento-guia`
 */
const section = (id: string, title: string, content: string): GuideSection => ({ id, title, content, iconUrl: null, images: [], videos: [] })

const SECTIONS: GuideSection[] = [
  section('entrar', 'Cómo entrar', 'Portal marrón junto a la farmacia. Ascensor a la 4.ª planta; la puerta del ático es la única del rellano.'),
  section('clima', 'Climatización', 'El mando está en la pared del salón. Modo frío o calor con el botón azul/rojo. Recomendamos 22 °C.'),
  section('lavadora', 'Lavadora y secadora', 'En el baño. Programa corto: botón «30 min». El detergente está bajo el lavabo.'),
  section('basura', 'Basura y reciclaje', 'Bolsa amarilla: envases. Azul: papel. Orgánico: contenedor marrón en la esquina de Toledo con Imperial.'),
  section('normas', 'Normas de la casa', 'Silencio de 22:00 a 8:00. No se puede fumar dentro ni en la terraza. Máximo 3 personas.'),
  section('salida', 'Salida', 'Hasta las 11:00. Deja las ventanas cerradas y las llaves físicas, si las hay, sobre la mesa.'),
]

/** Descripciones como las guarda el PMS: con HTML (manualList de la app actual). */
const HTML_SECTIONS: GuideSection[] = [
  section('basura', 'Basura y reciclaje', '<p>Separa los residuos:</p><ul><li><strong>Amarilla:</strong> envases</li><li><strong>Azul:</strong> papel</li></ul><p>Contenedores en la <a href="https://maps.google.es/?q=Toledo+Imperial+Madrid">esquina de Toledo con Imperial</a>.</p><script>alert(1)</script>'),
  section('normas', 'Normas de la casa', '<h2>Silencio</h2><p onclick="alert(2)">De 22:00 a 8:00.<br>No se puede fumar.</p>'),
]

const maps = (q: string) => `https://maps.google.es/?q=${encodeURIComponent(q)}`

const NEARBY: NearbyPlace[] = [
  { id: 'N-1', category: 'eat', name: 'Casa Lucio', note: 'Cocina castellana · 4 min a pie · reserva recomendada', photoUrl: null, mapsUrl: maps('Casa Lucio, Cava Baja 35, Madrid') },
  { id: 'N-2', category: 'eat', name: 'Mercado de San Miguel', note: 'Tapas y vermú · 3 min a pie', photoUrl: null, mapsUrl: maps('Mercado de San Miguel, Madrid') },
  { id: 'N-3', category: 'shop', name: 'Supermercado Plaza Mayor', note: 'Abierto hasta las 22:00 · 2 min a pie', photoUrl: null, mapsUrl: maps('Calle Mayor 30, Madrid') },
  { id: 'N-4', category: 'see', name: 'Palacio Real', note: 'Entrada gratis de 18:00 a 20:00 de lunes a jueves · 10 min a pie', photoUrl: null, mapsUrl: maps('Palacio Real de Madrid') },
  { id: 'N-5', category: 'kids', name: 'Parque del Retiro', note: 'Barcas y columpios · 20 min en metro', photoUrl: null, mapsUrl: maps('Parque del Retiro, Madrid') },
]

export const guiaMock: GuiaService = {
  async getGuide(stay, signal) {
    await simulate(stay.guestCode, 'guia', signal)
    const g = stay.guestCode
    const fromStay = guideFromStay(stay)
    const hotel = g.includes('hotel')
    const wifi = g.includes('guia-sin-wifi') ? null : fromStay.wifi && g.includes('guia-sin-clave') ? { ...fromStay.wifi, password: null } : fromStay.wifi
    return {
      wifi,
      sections: g.includes('guia-vacia') ? [] : g.includes('guia-html') ? HTML_SECTIONS : hotel ? fromStay.sections : SECTIONS,
      phones: fromStay.phones,
      nearby: hotel ? [] : NEARBY,
    }
  },
}
